import { uiSimpleBox } from 'components/BionicUI/CutCorners';
import { InputSearch } from 'components/BionicUI/ui/inputSearch';
import Eye from 'components/onboarding/Eye';
import { cn } from 'lib/utils';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { SearchContext } from './GlobalSearchPopup';
import { useKeyDown } from '@react-hooks-library/core';
import { Key } from 'ts-key-enum';
import React from 'react';

interface GlobalSearchInputProps {
  enterSearchTerm: (term: string) => void;
  searchTerm: string | null;
  searchContext?: SearchContext;
  handleClose: () => void;
}

export const placeholders = {
  global: 'Ask me anything about Bionic',
  project: 'Ask me anything about this project',
};

const GlobalSearchInput: FC<GlobalSearchInputProps> = ({
  enterSearchTerm,
  searchContext,
  handleClose,
}) => {
  const [inputValue, setInputValue] = useState<string>('');
  const input = useRef<HTMLInputElement>(null);
  const placeholder = useMemo(
    () => placeholders[searchContext?.scope ?? 'global'],
    [searchContext]
  );

  useEffect(() => {
    if (!input?.current) return;
    input.current?.focus();
  }, [input]);

  useKeyDown(['Enter'], () => {
    if (input?.current?.value) enterSearchTerm(input?.current?.value);
  });

  return (
    <div className="block relative w-full p-[8px]">
      <div className="block relative w-full h-[56px] rounded-[8px] bg-white/10 overflow-hidden cursor-pointer text-[16px] text-white/50">
        <GradBorder />
        <Glow />
        <div className="grid absolute top-0 left-0 w-full h-full grid-cols-[auto_1fr] gap-3 justify-start items-center p-[8px] pr-[24px]">
          <div className="block relative w-[40px] h-[40px]">
            <Eye showBorder />
          </div>
          <InputSearch
            ref={input}
            type="text"
            disabled={false}
            placeholder={placeholder}
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === Key.Escape) handleClose();
            }}
            className="block relative h-auto text-[16px]"
          />
        </div>
      </div>
    </div>
  );
};

const GradBorder = () => (
  <div
    className={cn(
      'block absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/30 to-white/5',
      uiSimpleBox.border
    )}
  />
);

const Glow = () => (
  <div className="grid absolute -top-[40px] left-0 w-full h-[40px] justify-center items-center">
    <div className="block relative w-[462px] h-[40px] bg-bionic-blue rounded-[50%] blur-[10px]" />
  </div>
);

export default GlobalSearchInput;
